import search from "./actions"

const rootReducer = {
   search
}
  
export default rootReducer